import { extractQueryState } from "@shared/utils/extractQueryState";
import { useQuery } from "@tanstack/react-query";
import { getSubscriptionPlansApiClient } from "@shared/apis/sidekick/api-factories";
import { GetAssignableSubscriptionPlansDto } from "@shared/apis/sidekick/generated";

type Props = {
  onSuccess?: (data: GetAssignableSubscriptionPlansDto) => void;
};

const CACHE_TIME_IN_MS = 1000 * 60 * 10; // 10 minutes

export const useGetSubscriptionPlans = (params?: Props) => {
  const { onSuccess } = params || {};

  const api = getSubscriptionPlansApiClient();
  const query = useQuery({
    queryKey: ["subscription-plans"],
    queryFn: async () => {
      try {
        const data = await api.subscriptionPlansControllerGetAll();
        onSuccess?.(data);
        return data;
      } catch (error) {
        console.error(`Failed to get subscription plans`, error);
        throw error;
      }
    },
    enabled: true,
    refetchInterval: false,
    refetchOnWindowFocus: false,
    gcTime: CACHE_TIME_IN_MS,
    staleTime: CACHE_TIME_IN_MS,
  });

  return extractQueryState(query);
};
